import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mx-15" }
const _hoisted_2 = { class: "card mb-xl-10 border border-primary comentarios mb-5 mt-5" }
const _hoisted_3 = { class: "card-body p-1 py-5 m-0" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-1 text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle fs-1 text-primary" })
], -1)
const _hoisted_6 = { class: "fs-4 fw-bold mb-3 col-11" }
const _hoisted_7 = { class: "fs-7 fw-normal me-5" }
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { class: "mb-2" }
const _hoisted_10 = { class: "py-5 mt-5" }
const _hoisted_11 = { class: "landingSubtitle" }
const _hoisted_12 = { class: "form-floating mb-5" }
const _hoisted_13 = { class: "form-label mb-3 required" }
const _hoisted_14 = { class: "input-group mb-5" }
const _hoisted_15 = { class: "form-floating flex-grow-1" }
const _hoisted_16 = { class: "form-label mb-3 required" }
const _hoisted_17 = { class: "form-floating mb-5" }
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = { class: "form-label mb-3 required" }
const _hoisted_20 = { class: "py-5 mt-5" }
const _hoisted_21 = { class: "landingSubtitle" }
const _hoisted_22 = { class: "fv-row mb-5" }
const _hoisted_23 = {
  class: "dropzone",
  id: "kt_dropzonejs_adjuntos"
}
const _hoisted_24 = { class: "dz-message needsclick" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-up text-primary fs-3x" }, null, -1)
const _hoisted_26 = { class: "ms-4" }
const _hoisted_27 = { class: "fs-5 fw-bolder text-gray-900 mb-1" }
const _hoisted_28 = { class: "fs-7 fw-bold text-gray-400" }
const _hoisted_29 = { class: "d-flex flex-stack justify-content-end pt-5" }
const _hoisted_30 = ["data-kt-indicator"]
const _hoisted_31 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 ms-2 me-0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-right" })
], -1)
const _hoisted_33 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("actualizarProfesional.textoInformativo1")), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("actualizarProfesional.textoInformativo2")), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("actualizarProfesional.textoInformativo3")), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.$t("actualizarProfesional.titulo")), 1)
    ]),
    _createElementVNode("form", {
      class: "mx-auto mw-900px w-100 pt-0 pb-10",
      novalidate: "novalidate",
      onSubmit: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.enviarFormulario && _ctx.enviarFormulario(...args)))
    }, [
      _createElementVNode("div", _hoisted_12, [
        _withDirectives(_createElementVNode("input", {
          name: "dni",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dni) = $event)),
          type: "text",
          class: "form-control form-control-lg form-control-solid",
          placeholder: " "
        }, null, 512), [
          [_vModelText, _ctx.dni]
        ]),
        _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.i18n("FamiliaDNILabel")), 1),
        _createVNode(_component_ErrorMessage, {
          name: "dni",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _withDirectives(_createElementVNode("input", {
            id: "telefono",
            name: "telefono",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.telefono) = $event)),
            type: "tel",
            class: "form-control form-control-lg form-control-solid",
            placeholder: " "
          }, null, 512), [
            [_vModelText, _ctx.telefono]
          ]),
          _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.i18n("FamiliaTelefonoLabel")), 1)
        ]),
        _createVNode(_component_ErrorMessage, {
          name: "telefono",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ]),
      _createElementVNode("div", _hoisted_17, [
        _withDirectives(_createElementVNode("textarea", {
          name: "detalleActualizacion",
          class: "form-control form-control-lg form-control-solid pe-10 resize-none min-h-100px",
          "data-kt-autosize": "true",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.detalleActualizacion) = $event)),
          placeholder: _ctx.$t('actualizarProfesional.datos.placeholder')
        }, null, 8, _hoisted_18), [
          [_vModelText, _ctx.detalleActualizacion]
        ]),
        _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("actualizarProfesional.datos.label")), 1),
        _createVNode(_component_ErrorMessage, {
          name: "detalleActualizacion",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("h3", _hoisted_21, _toDisplayString(_ctx.$t("actualizarProfesional.opcional")), 1)
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("h3", _hoisted_27, _toDisplayString(_ctx.$t("actualizarProfesional.adjuntar")), 1),
              _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("actualizarProfesional.hintText")), 1)
            ])
          ])
        ]),
        _createVNode(_component_ErrorMessage, {
          name: "titulacionAdjunta",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-lg btn-primary me-3",
            "data-kt-indicator": _ctx.isPendingForm ? 'on' : null
          }, [
            (!_ctx.isPendingForm)
              ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                  _createTextVNode(_toDisplayString(_ctx.$t("enviarBtn")) + " ", 1),
                  _hoisted_32
                ]))
              : _createCommentVNode("", true),
            (_ctx.isPendingForm)
              ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                  _createTextVNode(_toDisplayString(_ctx.$t("enviandoBtn")) + " ", 1),
                  _hoisted_34
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_30)
        ])
      ])
    ], 32)
  ]))
}